export const CREATED_BY_LABEL = 'Created by';
export const DELETE_BUTTON_LABEL = 'Delete';
export const DUPLICATE_BUTTON_LABEL = 'Duplicate';
export const EDIT_MENU_LABEL = 'Edit';
export const UNDEPLOY_BUTTON_LABEL = 'Undeploy';
export const SHARE_BUTTON_LABEL = 'Share';
export const DEPLOY_BUTTON_LABEL = 'Deploy';
export const TRY_AGAIN_BUTTON_LABEL = 'Try again';
export const CANCEL_BUTTON_LABEL = 'Cancel';
export const STATISTIC_HEADERS = {
  total_queries: 'Total Queries',
  manual_feedback_input: 'Feedback Items',
  users_provided_feedback: 'Feedback Contributors',
  avg_feedback_per_query: 'Avg. Feedback Per Query',
};
export const NUMBER_OF_LATEST_QUERIES_PER_PAGE = 5;
export const OBSERVABILITY_DASHBOARD_TOOLTIP = 'Groundedness Observability';
